import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const FullScreenSpinner = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="fullscreen-spinner">
      <div className="spinner-content">
        <ProgressSpinner />
        <h2>Se esta creando el presupuesto...</h2>
      </div>
    </div>
  );
};

export default FullScreenSpinner;
